import React, { Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { Redirect, matchPath } from 'react-router-dom';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('MultiStepForm');

export default class MultiStepForm extends Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        children: PropTypes.node.isRequired,
        horizontal: PropTypes.bool,
        timeline: PropTypes.bool,
        reverse: PropTypes.bool,
        isFetching: PropTypes.bool,
        className: PropTypes.string,
        headerElement: PropTypes.element,
        fastCheckoutAutoScroll: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        fastCheckoutAutoScroll: false,
    };

    constructor(props) {
        super(props);
        this.steps = [];
        this.state = {
            shouldScroll: props.fastCheckoutAutoScroll,
        };
    }

    handleStepClick = (shouldScroll = true) => {
        this.setState({ shouldScroll });
    };

    handleChange = (props) => {
        const { index } = props;
        this.steps[index] = props;
        // Don't redirect if `completed` is undefined as API hasn't loaded yet
        const redirectIndex = this.steps.findIndex(({ completed }) => typeof completed !== 'undefined' && !completed);
        const redirectPath = redirectIndex > -1 ? this.steps[redirectIndex].path : undefined;
        if (this.state.redirectIndex !== redirectIndex || this.state.redirectPath !== redirectPath) {
            this.setState({ redirectPath, redirectIndex });
        }
    };

    render() {
        const { children, match, location, horizontal, reverse, className, isFetching, headerElement, timeline = false } = this.props;
        const currentPath = location.pathname;
        const { locale } = match.params;
        const { shouldScroll } = this.state;
        const filteredChildren = React.Children.toArray(children).filter((child) => child !== null);

        return (
            <div className={bem(null, { horizontal, reverse, timeline }, className)}>
                {Children.map(filteredChildren, (child, index) => {
                    const { path, nextPath, exact } = child.props;
                    const stepPath = path.replace(':locale', locale);
                    const disabled = index > this.steps.findIndex(({ path }) => matchPath(currentPath, { path, exact }));

                    let redirect;

                    if (stepPath === currentPath && this.state.redirectPath && index > this.state.redirectIndex) {
                        redirect = <Redirect to={this.state.redirectPath.replace(':locale', locale)} />;
                    }

                    return [
                        redirect,
                        cloneElement(child, {
                            index,
                            disabled,
                            onChange: this.handleChange,
                            location, // Required, otherwise steps don't update properly when using browser's back button
                            nextPath: nextPath || (this.steps[index + 1] && this.steps[index + 1].path.replace(':locale', locale)),
                            isFetching,
                            headerElement,
                            horizontal,
                            handleStepClick: this.handleStepClick,
                            shouldScroll,
                        }),
                    ];
                })}
            </div>
        );
    }
}
